import { render, staticRenderFns } from "./PrimaryDetails.vue?vue&type=template&id=afac38ea&"
import script from "./PrimaryDetails.vue?vue&type=script&lang=js&"
export * from "./PrimaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports